import styled from 'styled-components';

export const LoadingPlaceholderWrapper = styled.div`
  text-align: center;
`;
